<script lang="ts">
import { defineComponent } from 'vue';
import { func, string } from 'vue-types';
import { Drawer } from 'ant-design-vue';

import Menu from './Menu.vue';

import useConfig from '@/providers/config/useConfig';

export default defineComponent({
  name: 'Navigation',
  components: {
    Menu,
    Drawer,
  },
  props: {
    class: string().def(''),
    visible: Boolean,
    onClose: func<() => void>().isRequired,
  },
  setup() {
    const { config } = useConfig();
    return {
      config,
    };
  },
});
</script>

<template>
  <div :class="$props.class">
    <Drawer
      :body-style="{ padding: 0 }"
      placement="left"
      :closable="false"
      :open="visible"
      @close="onClose"
    >
      <Menu />
    </Drawer>
    <Menu :collapsed="config.collapsed" />
  </div>
</template>
